module.exports = __webpack_public_path__ + "static/hyperv_4.84715e14.jpg";